import React from 'react';
import { Button } from '@mui/material';

const SubmitButton = ({ children, sx = {}, ...props }) => {
  return (
    <Button
      type="submit"
      variant="contained"
      color="primary"
      fullWidth
      sx={{
        py: 1,
        textTransform: 'none',
        fontWeight: 600,
        ...sx,
      }}
      {...props}
    >
      {children}
    </Button>
  );
};

export default SubmitButton;
